import ModelFactory from "../Definition/ModelFactory";
export class SearchModelFactory extends ModelFactory {
  register(type, constructor) {
    super.register(type, constructor);
  }
}